class SignalService {
  constructor($rootScope) {
    'ngInject';
    this.$rootScope = $rootScope;
  }

  send(signal, data) {
    this.$rootScope.$broadcast(signal, data);
  }

  listen(signal, scope ,callback) {
    var handler = this.$rootScope.$on(signal, function(event, data) {
      callback(data);
    });

    scope.$on('$destroy', handler);
  }

}
export default SignalService;
